module.exports = __webpack_public_path__ + "img/weixin1.32e168da.png";